// ---------- ouvrir une feuille depuis l'écran de progression ----------
// Les chiffres de « Moi » (ton plus grand puzzle) et d'« Ensemble » (le mieux noté de la semaine)
// proposent d'ouvrir une feuille. Ni profile.ts ni together.ts ne connaissent le catalogue : c'est
// progression.ts qui leur passe, au démarrage, de quoi l'ouvrir et de quoi savoir si elle y est —
// même sens de dépendance que `wireTogether(onGoDaily)` et `wireDaily(opener)`, sans import de
// home.ts qui refermerait une boucle.

let opener: (id: string) => void = () => {};
let known: (id: string) => boolean = () => false;
let packOpener: (packId: string) => void = () => {};

export function setSheetLinks(
  open: (id: string) => void,
  inCatalogue: (id: string) => boolean,
  openPack: (packId: string) => void,
): void {
  opener = open;
  known = inCatalogue;
  packOpener = openPack;
}

/** Ferme l'écran de progression et ouvre la page des packs, sur ce pack-là. */
export function openPack(packId: string): void {
  packOpener(packId);
}

/** Ferme l'écran de progression et ouvre la feuille, par le chemin d'une carte du catalogue. */
export function openSheet(id: string): void {
  opener(id);
}

/** Vrai si ce joueur peut l'ouvrir d'un tap : faux pour une feuille d'un pack pas débloqué. */
export function sheetInCatalogue(id: string): boolean {
  return known(id);
}
